import React from 'react'
import { SectionSearch, Toolbar, ToolbarRow } from '../../../../components'
import PropTypes from 'prop-types'

/**
 * Organization Toolbar
 * @param handleFilterChange
 * @return {*}
 */
const OrganizationToolbar = ({ handleFilterChange }) => {
  const handleSearchChange = (query) => handleFilterChange({ query, page: 1 })

  return (
    <Toolbar>
      <ToolbarRow justified>
        <SectionSearch
          className='toolbar_docked-element toolbar_docked-element--right'
          onQueryChange={handleSearchChange}
          onClear={handleSearchChange} />
      </ToolbarRow>
    </Toolbar>
  )
}

OrganizationToolbar.propTypes = {
  handleFilterChange: PropTypes.func.isRequired
}

export default OrganizationToolbar
